import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { LayoutComponent } from './layout/layout.component';
import { HeaderComponent } from './header/header.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { LoadingComponent } from './loading/loading.component';

import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    HeaderComponent,
    SidenavComponent,
    LoadingComponent,
    LayoutComponent,
  ],
  imports: [CommonModule, RouterModule, SharedModule],
})
export class FrameModule {}
